module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker86-api.relevant-digital.com/"}};